import { ReactNode } from "react";
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "@/components/shadcn/dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Button, ButtonVariant } from "@/components/shadcn/button";

export type FormDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerText?: string;
  triggerIcon?: IconProp;
  hideTrigger?: boolean;
  title: string;
  children: ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  submitText?: string;
  cancelText?: string;
  loading?: boolean;
  disableSubmit?: boolean;
  triggerVariant?: ButtonVariant;
  triggerClassName?: string;
  disableCloseOnOutsideClick?: boolean;
}

export const FormDialog = ({ open, onOpenChange, triggerText, triggerIcon, hideTrigger = false, title, children, onSubmit, submitText = "Save", cancelText = "Cancel", loading = false, disableSubmit = false, triggerVariant = "outline", triggerClassName, disableCloseOnOutsideClick = false }: FormDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {!hideTrigger && (
        <DialogTrigger asChild>
          <Button variant={triggerVariant} size={"sm"} className={triggerClassName}>
            {triggerIcon && <FontAwesomeIcon icon={triggerIcon} />}
            {triggerText}
          </Button>
        </DialogTrigger>
      )}
      <DialogContent className="sm:max-w-[600px]" onInteractOutside={disableCloseOnOutsideClick ? (e) => e.preventDefault() : undefined}>
        <form onSubmit={onSubmit}>
          <DialogHeader className="pb-6">
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          {children}
          <DialogFooter className="pt-6">
            <DialogClose asChild>
              <Button variant="outline" type="button" disabled={loading}>
                {cancelText}
              </Button>
            </DialogClose>
            <Button type="submit" variant="success" disabled={loading || disableSubmit}>
              {loading ? "Saving..." : submitText}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}